import gql from 'graphql-tag'

export const GET_ORGANIZATIONS_PAGINATION_QUERY = gql`
  query GetOrganizationsPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getOrganizationsPaginated(
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
          id
          title
          telNumber
          createdAt
      }
    }
  }
`
